import { Box, Button, Typography } from '@material-ui/core';
import React, { useState } from 'react';
import { Close } from '@material-ui/icons';

interface ImagePreviewerProps {
    imageUrl: string;
    onClose?: () => void;
}

export const ImagePreviewer: React.FC<ImagePreviewerProps> = ({
    imageUrl,
    onClose,
}) => {
    const [scale, setScale] = useState(1);
    const [position, setPosition] = useState({ x: 0, y: 0 });
    const [isDragging, setIsDragging] = useState(false);
    const [dragStart, setDragStart] = useState({ x: 0, y: 0 });

    const handleReset = (): void => {
        setScale(1);
        setPosition({ x: 0, y: 0 });
    };

    const handleMouseDown = (e: React.MouseEvent): void => {
        setIsDragging(true);
        setDragStart({
            x: e.clientX - position.x,
            y: e.clientY - position.y,
        });
    };

    const handleMouseMove = (e: React.MouseEvent): void => {
        if (isDragging) {
            setPosition({
                x: e.clientX - dragStart.x,
                y: e.clientY - dragStart.y,
            });
        }
    };

    const handleMouseUp = (): void => {
        setIsDragging(false);
    };

    const handleWheel = (e: React.WheelEvent): void => {
        e.preventDefault();
        const zoomFactor = 0.3;
        const delta = e.deltaY > 0 ? -zoomFactor : zoomFactor;

        setScale((prevScale) => {
            const newScale = prevScale + delta;
            return Math.min(Math.max(newScale, 1), 3);
        });
    };

    return (
        <Box
            sx={{
                position: 'relative',
                width: '100%',
                height: '80vh',
                minWidth: '900px',
            }}>
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    width: '100%',
                }}>
                <Typography variant="h6" fontSize={16}>
                    Preview (Esc to exit)
                </Typography>
                <Box
                    display='flex'
                    flexDirection='row'
                    alignItems='center'
                    justifyContent='center'
                    gap='10px'>
                    <Button
                        variant="contained"
                        onClick={() => window.open(imageUrl, '_blank')}>
                        Open in New Window
                    </Button>
                    <Button
                        variant="outlined"
                        // size="small"
                        onClick={handleReset}
                    >
                        Reset
                    </Button>
                    {onClose && (
                        <Close onClick={onClose} sx={{ cursor: 'pointer' }} />
                    )}
                </Box>
            </Box>
            <Box
                sx={{
                    width: '100%',
                    mt: '10px',
                    height: '90%',
                    overflow: 'hidden',
                    cursor: isDragging ? 'grabbing' : 'grab',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                }}
                onMouseDown={handleMouseDown}
                onMouseMove={handleMouseMove}
                onMouseUp={handleMouseUp}
                onMouseLeave={handleMouseUp}
                onWheel={handleWheel}>
                <img
                    src={imageUrl}
                    alt="Preview"
                    style={{
                        maxWidth: '100%',
                        maxHeight: '100%',
                        transform: `translate(${position.x}px, ${position.y}px) scale(${scale})`,
                        transition: isDragging ? 'none' : 'transform 0.2s',
                        transformOrigin: 'center center',
                    }}
                    draggable={false}
                />
            </Box>
        </Box>
    );
};
